import React, { useState } from "react";
import Select from "react-select";
import usStateOptions from "./usStateOptions";

const UsStateSelect = ({originalValue, name, onValueChanged, width="95%", small=false, placeholder="Select..." }) => {
  const formattedLocalValue = []
  if (originalValue != null && originalValue !== "")
  {
    formattedLocalValue.push({ value: originalValue, label: originalValue });
  }

  const [localValue, setLocalValue] = useState(formattedLocalValue);


  const onLocalValueChanged = (newValue) => {
    setLocalValue(newValue)
    onValueChanged(name, newValue.value)
  }

  const smallStyles = small ? {
    control: (base) => ({ ...base, minHeight: "29px" }),
    valueContainer: (base) => ({ ...base, padding: "0 6px" }),
    input: (base) => ({ ...base, margin: "0px", padding: "0px" }),
    indicatorsContainer: (base) => ({ ...base, height: "27px" }),
    dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
    clearIndicator: (base) => ({ ...base, padding: "4px" }),
  } : {};

  return (
    <div style={{width: width}}>
      <Select
        options={usStateOptions}
        value={localValue}
        onChange={(e) => {onLocalValueChanged(e)}} 
        isSearchable
        placeholder={placeholder}
        styles={smallStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
          ...theme.colors,
            primary50: '#DEF2F1',
            primary25: '#DEF2F1',
            primary: '#3AAFA9',
          },
        })}
      />
    </div>
  );
}

export default UsStateSelect;
